<script lang="ts">
    import type {ComponentSize, ComponentStyle} from '../types';

    export let buttonStyle: ComponentStyle = 'default';
    export let buttonSize: ComponentSize = 'md';
    export let menuAlignment: 'left' | 'right' = 'left';
    export let additionalClasses = '';
    export let id: string = null;

    const buttonClass = `btn-${buttonStyle} btn-${buttonSize}`;
</script>

<template>
    <span class="btn-group">
        <button type="button"
                id={id}
                class="btn {buttonClass} {additionalClasses}"
                on:click>
            <span><slot name="button"></slot></span>
        </button>
        <button type="button" class="btn {buttonClass} dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span class="caret"></span>
        </button>
        {#if $$slots.menu}
            <ul class="dropdown-menu" role="menu" class:dropdown-menu-right={menuAlignment === 'right'}>
                <slot name="menu"></slot>
            </ul>
        {/if}
    </span>
</template>

<style lang="less">
  .dropdown-menu {
    z-index: 1100;
  }
</style>